/**
 * Each global role tier as a person reads it, so the role badge and the
 * role-change dialog name a tier alike.
 */

import type { UserRole } from '@/types/auth'

export const ROLE_LABELS: Record<UserRole, string> = {
  admin: 'Admin',
  write: 'Operator',
  read: 'Viewer',
}
